import { useDateFormatter, useDateLocale } from "@l2r-front/l2r-i18n"

export function useFormatApiDateString() {

    const format = useDateFormatter()
    const locale = useDateLocale()

    return (dateString) => {
        if (!dateString) {
            return ""
        }
        const [monthIndex, year] = dateString.split("-")
        const date = new Date(parseInt(year), parseInt(monthIndex) - 1, 1)
        return format(date, "MMMM yyyy", { locale })
    }
}